module.exports = __webpack_public_path__ + "media/images/niq-right-2399f62b5c2d04f5b376819883abae0a.svg";